import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Divider, FullPageWrapper } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { SurveyFull } from 'entities/Surveys/model/SurveyFull'
import { ContactsDetails } from 'widgets/ContactsDetails'
import { ProviderViewPage, useViewPageContext } from 'pages/surveys/pages/view/context/viewContext'
import { ViewPageStore } from 'pages/surveys/pages/view/store/viewPageStore'
import { useSurveysIdContext } from 'pages/surveys/context/surveysIdContext'
import { ViewHeader } from 'pages/surveys/pages/view/ui/ViewHeader/ViewHeader'
import { AnalyticsCalendar } from 'pages/surveys/pages/view/ui/AnalyticsCalendar/AnalyticsCalendar'
import { ContactsTable } from 'pages/surveys/pages/view/ui/ContactsTable/ContactsTable'
import { StatisticsBlocks } from 'pages/surveys/pages/view/ui/StatisticsBlocks/StatisticsBlocks'
import { StatisticsDonutChart } from 'pages/surveys/pages/view/ui/StatisticsDonutChart/StatisticsDonutChart'
import styles from './styles.module.scss'

const ViewPageContent = observer(() => {
  const { init, initReactions, dispose, contactsDetailsStore } = useViewPageContext()

  useEffect(() => {
    init()
    initReactions()

    return () => {
      dispose()
    }
  }, [])

  return (
    <FullPageWrapper className={styles.page}>
      <ViewHeader />
      <Box display={'flex'} flexDirection={'column'} flex={1}>
        <AnalyticsCalendar />
        <StatisticsDonutChart />
        <StatisticsBlocks />
        <Divider
          sx={{
            margin: '9px 20px 30px',
            borderColor: 'var(--border-neutral-default)',
          }}
        />
        <ContactsTable />
      </Box>

      {contactsDetailsStore && <ContactsDetails store={contactsDetailsStore} />}
    </FullPageWrapper>
  )
})

export const ViewPage = observer(() => {
  const entities = useEntitiesContext()
  const response = useSurveysIdContext()
  const survey = new SurveyFull(response, entities)
  const [store] = useState(() => new ViewPageStore(survey, entities))

  return (
    <ProviderViewPage value={store}>
      <ViewPageContent />
    </ProviderViewPage>
  )
})
